import {EfeLabelValue} from 'commons/models';

export const INE_ID = '1';

export enum CONSTANT_VALUES {
    MexicoId = '187',
}

export enum CATALOGS {
    Countries = 'CAT_PAISES',
    States = 'CAT_ESTADOS',
    PersonTypes = 'CAT_TIPO_PERSONAS',
    Nationalities = 'CAT_NACIONALIDADES',
    RiskLevel = 'CAT_NIVELES_RIESGOS',
    // EconomicActivities = 'CAT_ACTIVIDADES_ECONOMICAS',
    EconomicActivitiesSummary = 'CAT_ACTIVIDADES_ECONOMICAS_RESUMEN',
    SourceIncome = 'CAT_FUENTE_INGRESOS',
    Giros = 'CAT_GIROS',
    MonetaryInstruments = 'CAT_INSTRUMENTOS_MONETARIOS',
    PersonRoles = 'CAT_ROLES_PERSONAS',
    PepDeclarative = 'CAT_DECLARATIVA_PEP',
    IdentificationTypes = 'CAT_TIPO_IDENTIFICACIONES',
    IssuingAuthority = 'CAT_AUTORIDAD_EMISORA',
    Genders = 'CAT_GENEROS',
    MaritalStatus = 'CAT_ESTADO_CIVIL',
    Questions = 'CAT_PREGUNTAS',
    MigratoryQuality = 'CAT_CALIDAD_MIGRATORIA',
    RecordStatus = 'CAT_ESTADOS_EXPEDIENTES',
    StockMarket = 'CAT_COTIZA_BOLSA',
    TransactionsNumber = 'CAT_NUMERO_TRANSACCIONES',
    TransactionsAmount = 'CAT_MONTO_TRANSACCIONES',
    AverageIncome = 'CAT_PROMEDIO_INGRESOS',
    Documents = 'CAT_DOCUMENTOS',
    Continents = 'CAT_CONTINENTES',
    Activities = 'CAT_OCUPACIONES',
    Variants = 'CAT_VARIANTES',
    Manuals = 'CAT_MANUALES',
    RealOwnerTypes = 'CAT_TIPO_PROPIETARIO_REAL',
}

export const CATALOGS_TO_ORDER: Array<string> = [
    'CAT_NUMERO_TRANSACCIONES',
    'CAT_MONTO_TRANSACCIONES',
    'CAT_PROMEDIO_INGRESOS',
    'CAT_FUENTE_INGRESOS',
];

export const INITIAL_CATALOGS_LOAD: Array<EfeLabelValue> = [
    {
        value: 'CAT_TIPO_PERSONAS',
        label: 'Cat\u00E1logo de Tipo de Personas',
    },
    {
        value: 'CAT_TIPO_PERSONAS_V2',
        label: 'Cat\u00E1logo de Tipo de Personas Accionistas',
    },
    {
        value: 'CAT_GENEROS',
        label: 'Cat\u00E1logo de Generos',
    },
    {
        value: 'CAT_TIPO_IDENTIFICACIONES',
        label: 'Cat\u00E1logo de Tipo de Identificaciones',
    },
    {
        value: 'CAT_ESTADOS',
        label: 'Cat\u00E1logo de Estados',
    },
    {
        value: 'CAT_PAISES',
        label: 'Cat\u00E1logo de Paises',
    },
    {
        value: 'CAT_NUMERO_TRANSACCIONES',
        label: 'Cat\u00E1logo de Numero de Transacciones',
    },
    {
        value: 'CAT_MONTO_TRANSACCIONES',
        label: 'Cat\u00E1logo de Monto de Transacciones',
    },
    {
        value: 'CAT_PROMEDIO_INGRESOS',
        label: 'Cat\u00E1logo de Promedio de Ingresos',
    },
    {
        value: 'CAT_FUENTE_INGRESOS',
        label: 'Cat\u00E1logo de Fuente de Ingresos',
    },
    {
        value: 'CAT_GIROS',
        label: 'Cat\u00E1logo Giro Mercantil',
    },
    {
        value: 'CAT_TIPO_PROPIETARIO_REAL',
        label: 'Cat\u00E1logo de Propietario Real',
    },
    {
        value: 'CAT_BANCOS',
        label: 'Cat\u00E1logo de bancos',
    },
    {
        value: 'CAT_ACTIVIDADES_ECONOMICAS',
        label: 'Cat\u00E1logo de actividades económicas',
    },
];

export enum Device {
    Desktop = 'D',
    Mobile = 'M',
}

export enum Status {
    Active = 'A',
    Inactive = 'I',
}

export enum ColorVariant {
    Primary = 'PRIMARY',
    Secondary = 'SECONDARY',
}

/** Field Element Type Variant */
export enum TypeVariant {
    Radiobutton = 'RADIOBUTTON',
    Text = 'TEXT',
}

/** Field Style Variant */
export enum StyleVariant {
    Outlined = 'OUTLINED',
}
